import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate3x.svg'

export const IconPlaybackRate3x = IconSVG as IconComponent
